import { Injectable, Output } from '@angular/core';

@Injectable()
export class Global {
  // public isDisabledField= true;


  public isDisabledField() {
    let user;
    user = sessionStorage.getItem('loggedUser');
    user = JSON.parse(user);
    // console.log('[LOGGGED]', user);

    if (user) {
      if (user.data.role === 'Leitor-Avaliador' || user.data.role === 'Leitor-Usuário') {
        return true;
      }
      return false;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/global.ts